import React from 'react';
import SyllabusSection from '../components/AcademicsComponents/SyllabusSection';


const SyllabusPage = () => {
  return (
    <div className='SyllabusPage'>
      <SyllabusSection />
    </div>
  );
};

export default SyllabusPage;
